export class NewAuthAttachment {
  docStorageId!: string;
  docDisplayName!: string;
  docType!: number;
  docUrl!: string;
}
